<template>
  <a href="#" @click.prevent="loginKakao">
    <span class="sns-center">
      <span class="icon-sns icon-kakao"></span>
      <span class="txt-sns">카카오로 시작하기</span>
    </span>
  </a>
</template>

<script>
/* eslint-disable */
import { setLibFile } from '@/common/plugins/sns.lib'
import utils from '@/common/util/utils'
import { parseUrl, stringify } from 'query-string'
import { get } from 'lodash'
const SIGN_UP_RESULT_CODE = '302'

export default {
  name: 'BtnKakao',
  props: {
    showProfileFn: {
      type: Function
    },
    closeOnSuccessFn: {
      type: Function
    },
    promotionCode: {
      type: String
    }
  },
  methods: {
    login (token) {
      utils.login.loginProc({
        userType: 'kakao',
        userId: token,
        userPassword: '',
        saveId: '',
        autoLogin: ''
      }, (error)=> {
        if (error.response.status === 551 && get(error, 'response.data.resultoptional', '') !== '' &&
          error.response.data.resultcode === SIGN_UP_RESULT_CODE) {
          const { url, query } = parseUrl(error.response.data.resultoptional)
          if (this.promotionCode !== '') query.promotioncode = this.promotionCode
          window.location.href = `${url}?${stringify(query)}`
        }
      }).then(({ data }) => {
        if (data.needselectprofile === 'y') { // 프로필 선택 화면이 필요하면
          this.showProfileFn()
        } else {
          this.closeOnSuccessFn()
        }
      })
    },
    loginKakao() {
      let self = this;
        Kakao.Auth.login({
          success: function() {
            self.login(Kakao.Auth.getAccessToken());
          },
          fail: function(err) {
            console.log(err);
          }
        });
    }
  },
  created() {
    window.kakaoAsyncInit = function() {
      Kakao.init('30fc7e17b5c56a0ca1e861643292c203');
    };
    // let intervalTimer =  setInterval(() => {
    //   if(Kakao)  {
    //     Kakao.init('30fc7e17b5c56a0ca1e861643292c203');
    //     clearInterval(intervalTimer)
    //   }
    // }, 100)
    setLibFile(document, 'script', 'kakao-jssdk', '//developers.kakao.com/sdk/js/kakao.min.js');
  }
};
</script>
